import React from 'react';

interface Option {
  id: number;
  name: string;
}

interface MultiDropdownFieldProps {
  label: React.ReactNode;
  values: string[]; // 各ドロップダウンで選ばれた値（文字列なので、option.idとの比較でキャストが必要な場合も）
  options: Option[];
  count: number;
  height?: number;
  onChange: (newValues: string[]) => void;
}

export const MultiDropdownField: React.FC<MultiDropdownFieldProps> = ({
  label,
  values,
  options,
  count,
  height = 33,
  onChange,
}) => {
  return (
    <div className="mb-6 border-b border-gray-400 w-full">
      <div className="flex items-start my-3 w-full">
        <label className="font-bold w-1/6">{label}</label>
        <div className="w-1/6 text-sm text-gray-600 whitespace-nowrap overflow-hidden text-ellipsis"></div>
        <div className="w-5/6">
          {Array.from({ length: count }).map((_, index) => {
            // 現在のドロップダウン以外で選択されている値（空文字は除外）
            const otherSelected = values.filter(
              (value, i) => i !== index && value !== ''
            );

            // 現在の値は選択肢から外さないため、現在の選択値の場合はそのまま表示する条件を付与
            const availableOptions = options.filter((option) => {
              // 選択済みの値と比較するため、option.id を文字列に変換
              if (String(option.id) === values[index]) {
                return true;
              }
              return !otherSelected.includes(String(option.id));
            });

            return (
              <select
                key={index}
                value={values[index] || ''}
                onChange={(e) => {
                  const newValues = [...values];
                  newValues[index] = e.target.value;
                  onChange(newValues);
                }}
                className="block border border-gray-400 px-2 bg-white w-full mb-2 max-w-[500px]"
                style={{ height: `${height}px` }}
              >
                <option value="">選択してください</option>
                {availableOptions.map((option) => (
                  <option key={option.id} value={option.id}>
                    {option.name}
                  </option>
                ))}
              </select>
            );
          })}
        </div>
      </div>
    </div>
  );
};
